import styles from "./featured-icon.module.scss";
import { IFeaturedIcon } from "../../types/featured_icon/featuredIcon";

export const FeaturedIcon = ({
    size = 'md',
    color = 'gray',
    variant = 'contained',
    icon,
    keepIconDefaultColors = false
}: IFeaturedIcon) => {
    return (
        icon &&
        <div
            className={styles['featured-icon']}
            data-featured-icon-size={size}
            data-featured-icon-color={color}
            data-featured-icon-keep-default-color={keepIconDefaultColors}
            data-featured-icon-variant={variant}
        >
            {icon}
        </div>
    )
}